/*
 * @Autor: GeekMzy
 * @Date: 2022-04-18 10:32:53
 * @LastEditors: GeekMzy
 * @LastEditTime: 2022-06-29 06:36:57
 * @FilePath: \htwlgs-drainage-webv2.2\src\store\main.ts
 * @Author: desktop-1llkr2o
 */
import { defineStore } from 'pinia'

export const useMainStore = defineStore({
  id: 'mian',
  state: () => ({
    name: '超级管理员',
    menu: 'main',
    topMenu: 'basic_profile',
    leftMenu: {},
    currentLeftMenu: '',
    currentLy: '永川全区域',
    currentRiver: '',
    customer: true,
    terrain: false,
    mapLegenf: new Set(),
    legendType: 1,
  }),
  getters: {
    nameLength: (state: { name: string | any[] }) => state.name.length,
  },
  actions: {
    changeLy(ly: any) {
      this.currentLy = ly
      console.log('changeLy', ly)
    },
    changeRiver(river: any) {
      this.currentRiver = river
      console.log('changeRiver', river)
    },
    changeLeftMenu(menu: any) {
      this.leftMenu = menu
      console.log('changeLeftMenu', menu)
    },
    changeTopMenu(key: any) {
      this.topMenu = key
      console.log('changeTopMenu', key)
    },
    changeCurrentLeftMenu(key: any) {
      this.currentLeftMenu = key
      console.log('changeCurrentLeftMenu', key)
    },
    changeCustomer(state: any) {
      this.customer = state
    },
    changeTerrain(state: any) {
      this.terrain = state
    },
    addMapLegenf(val: any) {
      this.mapLegenf.add(val)
    },
    deleteMapLegenf(val: any) {
      this.mapLegenf.delete(val)
    },
    setLegendType(val: any) {
      this.legendType = val
    }
  },
})
